import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import moment from "moment";
import { toCamel } from 'snake-camel';
import { WorkRecordGet } from "@/types/Component";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import { CsvDownload } from '@/types/APIResponse';
import WorkRecordModal from '@/assets/common/Modal/WorkRecordModal/WorkRecordModal.vue';
import HarvestRecordModal from '@/assets/common/Modal/HarvestRecordModal/HarvestRecordModal.vue';
import ShippingRecordModal from '@/assets/common/Modal/ShippingRecordModal/ShippingRecordModal.vue';
import PlantingModal from '@/assets/common/Modal/PlantingModal/PlantingModal.vue';
import { LoginUser } from "@/types/Component";


interface Fertilizer {
    unitName: string;
    fertilizerName: string;
    fertilizerUsage: number;
}
interface Chemicals {
    unitName: string;
    chemicalName: string;
    chemicalUsage: number;
}

@Component({
    components: {
        EmptyGraphMessage,
        WorkRecordModal,
        HarvestRecordModal,
        ShippingRecordModal,
        PlantingModal
    }
})
export default class WorkRecordList extends Vue {
    screen = 'WORKRECORDLIST';
    private list: any | null = null
    private title = '作業一覧'
    baseUrl = '/work_records_list';
    selectScreenManagement = '/graphScreenManagement';
    selectedStartDate: string | Date = new Date();
    selectedEndDate: string | Date = new Date();
    startDate: string | Date = new Date();
    endDate: string | Date = new Date();
    private workRecordsList =  [] as any[];
    private allWorkRecordsList =  [] as any[];
    private selectedAgriFieldId : string | null = null;
    private selectedPlantingId : string | null = null;
    private selectedWorkItemId : string | null = null;
    private selectedWorkerId : string | null = null;
    private isButtonDisabled = false;
    private selectedWorkKind ="ACTUAL";
    private agriFields = [] as any[];
    private plantings = [] as any[];
    private workers = [] as any[];
    private workItems = [] as any[];
    private selectedPlantingName = '';
    private selectedAgriFieldName = '';
    private selectedWorkItemName = '';
    private selectedWorkerName = '';
    private isFilePopUp = false;
    private images: File[] = [];
    private isSpinnerLoading = false;
    private  totalWorkTimeValue = "";
    private sortOrder = true;
    private totalActualWorkerWorkingTime =0;
    private totalPlanWorkerWorkingTime =0;
    private isShow = false;
    private isShowHarvest = false;
    private isShowShipping = false;
    private isRefresh = false;
    private selectedWorkRecordId ='';
    private selectedHarvestRecordId ='';
    private selectedShippingRecordId ='';
    private harvestRecordId = '';
    private shippingRecordId = '';
    private mode = '';
    private isWorkRecordPopup = '';
    private recordDate = '';
    private isPlantingShow = false
    includeHiddenFlag = false
    isFeeDisplay = false;
    isCostNotRegister = false;

    get isAdmin(): boolean {
        return this.loginUser.role.find((r: string) => {
            return r === 'ADMIN'
        }) !== undefined;
      }
    
    get loginUser(): LoginUser {
        return this.$store.getters.loginUser;
    }

    get isWorkListOpen():boolean{
        return(
            this.isPlantingShow ||
            this.isShowHarvest ||
            this.isShow ||
            this.isShowShipping 
        )
    }

    private created() {
        this.routeparams(this.$route);
        const currentDate = new Date();
        this.selectedStartDate = moment(currentDate).startOf('month').format('YYYY-MM-DD');
        this.selectedEndDate = moment(currentDate).endOf('month').format('YYYY-MM-DD');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.isSpinnerLoading = true;
        this.getWorkRecordList(1);
        this.getAgriFields();
        this.getPlantings();
        this.getWorkers();
        this.getWorkItems();
    }

    routeparams(params:any){
        this.isWorkRecordPopup =params.query.isWorkRecordPopup
        this.selectedWorkRecordId = params?.query?.recordId
        this.recordDate = params?.query?.date
        this.harvestRecordId = params?.query?.harvestRecordId
        this.shippingRecordId = params?.query?.shippingRecordId
        if(this.isWorkRecordPopup || this.selectedWorkRecordId){
            if(this.isWorkRecordPopup ==="true" && this.selectedWorkRecordId == null){
                this.openWorkRecordModalCalendar( '', 'add')
            }
            else if(this.isWorkRecordPopup ==="true" && this.selectedWorkRecordId != null){
                this.openWorkRecordModalCalendar(this.selectedWorkRecordId, 'edit')
            }
        }
    }

    getWorkRecordList(page:number) {
        this.$apiClient.doRequest('get', `${this.baseUrl}?isCost_notRegister=${this.isCostNotRegister}`).then(res => {
        setTimeout(() => {
            this.isSpinnerLoading = false;
            }, 500);
          this.workRecordsList = res.recordList
          this.allWorkRecordsList = res.recordList
          if(res.selectedItems!=null){
            this.selectedAgriFieldId = res.selectedItems.agriFieldId
            this.selectedPlantingId = res.selectedItems.plantingId
            this.selectedWorkItemId = res.selectedItems.workItemId
            this.selectedWorkerId = res.selectedItems.userId
            this.selectedWorkKind = res.selectedItems.workKind ? res.selectedItems.workKind : 'ACTUAL';
            this.selectedStartDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.selectedEndDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.startDate = res.selectedItems.displayFromDate ? res.selectedItems.displayFromDate : ""
            this.endDate = res.selectedItems.displayToDate ? res.selectedItems.displayToDate : ""
            this.isFeeDisplay = res.selectedItems.feeDisplay
            this.includeHiddenFlag = res.selectedItems.includeHiddenFlag
            if ((this.selectedStartDate > this.selectedEndDate) || (this.selectedStartDate === '' && this.selectedEndDate === '') || (this.selectedStartDate === '' && this.selectedEndDate !== '') 
                || (this.selectedStartDate !== '' && this.selectedEndDate === '')) {
                this.isButtonDisabled = true;
              }else{
                this.isButtonDisabled = false;
              } 
          }
          
          if (this.selectedWorkKind == "ACTUAL") {
            this.totalActualWorkerWorkingTime = res.recordList.reduce((total: number, obj: any) => {
                return total + parseFloat(obj.workerWorkingTime || "0"); 
            }, 0);
            this.totalWorkTimeValue = this.convertEnglishTime(this.totalActualWorkerWorkingTime);
          }else{
            this.totalPlanWorkerWorkingTime = res.recordList.reduce((total: number, obj: any) => {
                return total + parseFloat(obj.planWorkingTime || "0"); 
            }, 0);
            this.totalWorkTimeValue = this.convertEnglishTime(this.totalPlanWorkerWorkingTime);
          }
        })
    }
    
    handleSelectChange(flag = true) {
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        this.selectedWorkerName = this.workers.find(item=>item.id==this.selectedWorkerId)?.name
        const params = {
          plantingId: this.selectedPlantingId,
          agriFieldId: this.selectedAgriFieldId,
          selectedWorkId: this.selectedWorkItemId,
          userId: this.selectedWorkerId,
          startDate: this.selectedStartDate,
          endDate: this.selectedEndDate,
          workKind:this.selectedWorkKind,
          screenName: this.screen,
          includeHiddenFlag: this.includeHiddenFlag,
          feeDisplay : this.isFeeDisplay
        }
        this.$apiClient.doRequest('post', `${this.selectScreenManagement}`,params).then(res => {
            if (flag) {
                this.refreshTable();
            }
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    } 

    validateDates() {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        if (this.selectedStartDate > this.selectedEndDate) {
          this.selectedStartDate = this.startDate;
          this.selectedEndDate = this.endDate;
          this.isButtonDisabled = true;
        } else {
          this.isButtonDisabled = false;
          this.startDate = this.selectedStartDate;
          this.endDate = this.selectedEndDate;
        }
    }

    getAgriFields() {
        this.$apiClient.doRequest('get','/agri_fields?with_hidden=true').then((res) => {
        this.agriFields = res.agri_fields
        this.selectedAgriFieldName = this.agriFields.find(item=>item.id==this.selectedAgriFieldId)?.name
        })
    }

    getPlantings() {
        this.$apiClient.doRequest('get','/plantings?with_hidden=true').then((res) => {
        this.plantings = res.plantings.sort((a:any,b:any) => a.name.localeCompare(b.name))
        this.selectedPlantingName = this.plantings.find(item=>item.id==this.selectedPlantingId)?.name
       })
    }

    getWorkers() {
        this.$apiClient.doRequest('get','/workers/with_deleted_worker').then((res) => {
        this.workers = res.workers
        this.selectedWorkerName = this.workers.find(item=>item.id==this.selectedWorkerId)?.name
        })
    }

    getWorkItems() {
        this.$apiClient.doRequest('get','/work_items?with_hidden=true').then((res) => {
        this.workItems = res.work_items
        this.selectedWorkItemName = this.workItems.find(item=>item.id==this.selectedWorkItemId)?.name
        })
    }

    private convertEnglishTime(time: number): string {
        if(time){
        if (time % 60 === 0) {
            return Math.floor(time / 60).toLocaleString('ja-JP') + " h ";
        } else if(time > 60) {
            return Math.floor(time / 60).toLocaleString('ja-JP') + " h " + Math.floor(time % 60) + " m ";
        } else {
            return time + "m";
        }
    }
    else{
        return 0 + "m";
    }
    }
    private convertDate(date: Date): string {
        if (date) {
            const d = new Date(date);
            return `${d.getFullYear()}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getDate().toString().padStart(2, '0')}`;
        }
        return "-";
    }

    dateNavigation(action: string) {
        if (!this.selectedStartDate || !this.selectedEndDate) return;
        this.validateDates()
        if(this.isButtonDisabled == false){
        const updateDate = (date: moment.MomentInput, offset: moment.DurationInputArg1, unit: moment.unitOfTime.Base) => moment(date).add(offset, unit).format('YYYY-MM-DD');
        const daysDifference = moment(this.selectedEndDate).diff(this.selectedStartDate, 'days')+1;
        const offset = (action === 'previous') ? -daysDifference : daysDifference;
        this.selectedStartDate = updateDate(this.selectedStartDate, offset, 'days');
        this.selectedEndDate = updateDate(this.selectedEndDate, offset, 'days');
        this.startDate = this.selectedStartDate;
        this.endDate = this.selectedEndDate;
        this.handleSelectChange();
        } else {
            this.isButtonDisabled = false
        }
    }

    csvDownload(){
        this.$apiClient.getRequest( `${this.baseUrl}/csv_export?&start_date=${this.selectedStartDate}&end_date=${this.selectedEndDate}&planting=${this.selectedPlantingName?this.selectedPlantingName:""}&agri_field_name=${this.selectedAgriFieldName?this.selectedAgriFieldName:""}&workItem=${this.selectedWorkItemName?this.selectedWorkItemName:""}&workerName=${this.selectedWorkerName?this.selectedWorkerName:""}&isCost_notRegister=${this.isCostNotRegister}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        }).catch(error=>{
            this.$toasted.error('データの取得に失敗しました。')
        })
    }

    // handleScroll() {
    //     const dataTableBox = this.$refs.dataTableBox as HTMLDivElement;
    //     const bottomOffset = 20;
    //     if (dataTableBox.scrollTop + dataTableBox.clientHeight >= dataTableBox.scrollHeight - bottomOffset) {
    //       const currentPage = Math.ceil(this.workRecordsList.length / this.pageSize) + 1;
    //       this.getWorkRecordList(currentPage);
    //     }
    // }

   private processData(workersInfo: string): string[] {
        const responses: string[] = [];
    
        if (workersInfo == null) {
            return responses;
        }
    
        try {
            const workersArray = JSON.parse(workersInfo);
    
            if (!Array.isArray(workersArray) || workersArray.length === 0) {
                return responses;
            }
    
            workersArray.forEach((worker: { [key: string]: number }, index: number) => {
                const name = Object.keys(worker)[0];
                const time = this.minuteToHour(worker[name]);
                responses.push(`${name} : ${time}`);
            });
    
        } catch (error) {
            // Handle the error if needed
        }
        return responses;
    }

    private processAmountData(amountInfo: string): string[] {
        if (!amountInfo) {
            return [];
        }
    
        return amountInfo.split('、').map(item => {
            const parts = item.split(':');
            const name = parts[0].trim();
            const amount = Number(parts[1]?.trim());
        
            return amount === 0 ? `${name} : ---` : `${name} : ${amount.toLocaleString('ja-jp')} 円`;
          });
    }
    
    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '---';
    }

    private workerCount(workerNames: string): number {
        if(workerNames!=null){
            return workerNames.split(',').length;
        }else{
            return 0
        }
    }

    private workerNameFormatChange(workerName: string): string[] {
        if(workerName!=null){
            const namesArray  = workerName.split(',').map(name => name.trim());
            return namesArray;
        }else{
            return []
        }
    }

    private processDataChemicals(chemicalInfo: string): string[] {
        const responses: string[] = [];
        if (chemicalInfo == null) {
            return responses;
        }
        try {
            const chemicalData = JSON.parse(chemicalInfo);
    
            if (Array.isArray(chemicalData)) {
                chemicalData.forEach((item: any) => {
                    const chemicalName = item["chemicalName"];
                    const chemicalUsage = item["chemicalUsage"];
                    const unitName = item["unitName"];
    
                    const formattedString = `${chemicalName}:${chemicalUsage.toLocaleString('ja-jp')}${unitName}`;
                    responses.push(formattedString);
                });
            } else {
                console.error("Invalid input format. Expected an array.");
            }
        } catch (error) {
            console.error("Error parsing chemicalInfo:", error);
        }
    
        return responses;
    }
   
    private processDataFertilizer(fertilizerInfo: string): string[] {
        const responses: string[] = [];
        if (fertilizerInfo == null) {
            return responses;
        }
        try {
            const fertilizerData = JSON.parse(fertilizerInfo);
    
            if (Array.isArray(fertilizerData)) {
                fertilizerData.forEach((item: any) => {
                    const fertilizerName = item["fertilizerName"];
                    const fertilizerUsage = item["fertilizerUsage"];
                    const unitName = item["unitName"];
    
                    const formattedString = `${fertilizerName}:${fertilizerUsage.toLocaleString('ja-jp')}${unitName}`;
                    responses.push(formattedString);
                });
            } else {
                console.error("Invalid input format. Expected an array.");
            }
        } catch (error) {
            console.error("Error parsing chemicalInfo:", error);
        }
    
        return responses;
    }

    private processDataFertilizerAmount(fertilizerAmountInfo: string): string[] {
        const responses: string[] = [];
        if (!fertilizerAmountInfo) {
            return responses;
        }
        try {
            const amountData = JSON.parse(fertilizerAmountInfo);
    
            if (Array.isArray(amountData)) {
                amountData.forEach((item: any) => {
                    const fertilizerName = item["fertilizerName"];
                    const usageAmount = item["usageAmount"];
    
                    const formattedAmount = Math.round(Number(usageAmount)).toLocaleString() + " 円";
                    const formattedString = `${fertilizerName}:${formattedAmount}`;
                    responses.push(formattedString);
                });
            } else {
                console.error("Invalid input format. Expected an array.");
            }
        } catch (error) {
            console.error("Error parsing fertilizerAmountInfo:", error);
        }
    
        return responses;
    }    

    private processDataChemicalAmount(chemicalAmountInfo: string): string[] {
        const responses: string[] = [];
        if (!chemicalAmountInfo) {
            return responses;
        }
        try {
            const amountData = JSON.parse(chemicalAmountInfo);
    
            if (Array.isArray(amountData)) {
                amountData.forEach((item: any) => {
                    const chemicalName = item["chemicalName"];
                    const usageAmount = item["usageAmount"];
    
                    const formattedAmount = Math.round(Number(usageAmount)).toLocaleString() + " 円";
                    const formattedString = `${chemicalName}:${formattedAmount}`;
                    responses.push(formattedString);
                });
            } else {
                console.error("Invalid input format. Expected an array.");
            }
        } catch (error) {
            console.error("Error parsing chemicalAmountInfo:", error);
        }
    
        return responses;
    }

   private processDataExpendable(expendableMaterialInfo: string): string[]{
        const responses: string[] = [];
        if (expendableMaterialInfo == null) {
            return responses;
        }
    
        try {
            const materialsArray = JSON.parse(expendableMaterialInfo);
    
            if (!Array.isArray(materialsArray) || materialsArray.length === 0) {
                return responses;
            }
    
            materialsArray.forEach((worker: { [key: string]: number }, index: number) => {
                const name = Object.keys(worker)[0];
                const time = (worker[name].toLocaleString('ja-jp'));
                responses.push(`${name} : ${time}`);
            });
    
        } catch (error) {
            // Handle the error if needed
        }
        
        return responses;

    }

    private processDataDepreciation(depreciationMaterialInfo: string): string[]{
        const responses: string[] = [];
        if (depreciationMaterialInfo == null) {
            return responses;
        }
    
        try {
            const materialsArray = JSON.parse(depreciationMaterialInfo);
    
            if (!Array.isArray(materialsArray) || materialsArray.length === 0) {
                return responses;
            }
    
            materialsArray.forEach((worker: { [key: string]: number }, index: number) => {
                const name = Object.keys(worker)[0];
                const time = (this.minuteToHourConvertionMaterialInfo(worker[name]));
                responses.push(`${name} : ${time}`);
            });
    
        } catch (error) {
            // Handle the error if needed
        }
        
        return responses;
    }

    private minuteToHourConvertionMaterialInfo(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '1回';
    }

   private getWorkRecordFile(workRecordId:string){
     this.$apiClient.doRequest('get', '/work_records/' +workRecordId ).then(ret => {
         const item = toCamel(ret) as WorkRecordGet
        if(item.imageId.length > 0) {
            const promise: any = []
            item.imageId.forEach((id: string) => {
                promise.push(this.$apiClient.doRequest('get', `/work_records/${workRecordId}/images/${id}`))
            })
            Promise.all(promise).then(ret => {
                const file = toCamel(ret) as File[]
                this.images = file
                this.isFilePopUp =true;
            })
        }
     }).catch(error=>{
        this.$toasted.error('データの取得に失敗しました。')
    })
   }

   private closeModalPopup(){
    this.isFilePopUp =false;
  }

  private sumMaterialUsage(expendableMaterialUsage: string) {
    if (expendableMaterialUsage == null) {
        return "";
    }else{
    const values = expendableMaterialUsage.split(',');
    const sum = values.reduce((acc, value) => acc + parseFloat(value), 0);
    return sum.toLocaleString("ja-JP");
    }
  }

  private processFertilizerUsage(fertilizerInfo: string): string {
    if (fertilizerInfo == null) {
        return "";
    }
    try {
      const fertilizerArray: Fertilizer[] = JSON.parse(fertilizerInfo);
  
      const unitMap: { [unitName: string]: number } = {};
  
      for (const fertilizer of fertilizerArray) {
        const { unitName, fertilizerUsage } = fertilizer;
  
        if (unitMap[unitName]) {
          unitMap[unitName] += fertilizerUsage;
        } else {
          unitMap[unitName] = fertilizerUsage;
        }
      }
  
      const result = Object.entries(unitMap)
        .map(([unitName, totalUsage]) => `${totalUsage.toLocaleString("ja-JP")}${unitName}`)
        .join(',\n');
  
      return result;
    } catch (error) {
      console.error("Error processing fertilizer usage:", error);
      return ""; // Handle the error as needed
    }
  }
  private processChemicalUsage(chemicalInfo: string): string {
    if (chemicalInfo == null) {
        return "";
    }
    try {
      const chemicalArray: Chemicals[] = JSON.parse(chemicalInfo);
  
      const unitMap: { [unitName: string]: number } = {};
  
      for (const chemicals of chemicalArray) {
        const { unitName, chemicalUsage } = chemicals;
  
        if (unitMap[unitName]) {
          unitMap[unitName] += chemicalUsage;
        } else {
          unitMap[unitName] = chemicalUsage;
        }
      }
  
      const result = Object.entries(unitMap)
        .map(([unitName, totalUsage]) => `${totalUsage.toLocaleString('ja-jp')}${unitName}`)
        .join(',\n');
  
      return result;
    } catch (error) {
      console.error("Error processing chemicals usage:", error);
      return ""; // Handle the error as needed
    }
  }

  private sort(fieldName: string): void {
    this.sortOrder = !this.sortOrder;
    this.workRecordsList.sort((a, b) => {
        const aValue = a[fieldName];
        const bValue = b[fieldName];
        if (aValue === null && bValue === null) return 0;
        if (aValue === null) return 1;
        if (bValue === null) return -1;
        const aNum = Number(aValue);
        const bNum = Number(bValue);
        const isANum = !isNaN(aNum);
        const isBNum = !isNaN(bNum);
        if (isANum && isBNum) {
            return this.sortOrder ? aNum - bNum : bNum - aNum;
        }
        if (typeof aValue === 'string' && typeof bValue === 'string') {
            return this.sortOrder
                ? aValue.localeCompare(bValue)
                : bValue.localeCompare(aValue);
        }
        return this.sortOrder
            ? String(aValue).localeCompare(String(bValue))
            : String(bValue).localeCompare(String(aValue));
    });
}
 private processDepreciation(depreciationMaterialInfo: string) {
     if(depreciationMaterialInfo == null){
        return "";
     }
     let sum = 0;
     let nullCount = 0;

     try {
        const jsonArray = JSON.parse(depreciationMaterialInfo);
        jsonArray.forEach((obj: { [key: string]: number | null }) => {
            for (const key in obj) {
                if (Object.hasOwnProperty.call(obj, key)) {
                    const value = obj[key];
                    if (value === null || value  === 0) {
                        nullCount++; // Increment null count
                    } else if (!isNaN(value as number)) {
                        sum += value; // Add to sum if not null
                    }
                }
            }
        });
    } catch (error) {
        console.error("Error parsing JSON:", error);
    }

    if(sum!=0&&nullCount!=0){
     const hours = this.minuteToHour(sum);
     const nullableCount = nullCount+"回"
     return  `${hours} 、${nullableCount}` ;
    }else if(sum!=0){
     const hours = this.minuteToHour(sum); 
     return `${hours}` ;
    }else{
     const nullableCount = nullCount.toLocaleString("ja-JP")+"回"
     return  `${nullableCount}` ;
    }
 }

    openWorkRecordModal(id = '',harvestRecordId='',shippingRecordId='',mode = '') {
        this.selectedWorkRecordId = id;
        this.harvestRecordId = harvestRecordId;
        this.shippingRecordId = shippingRecordId;
        this.mode = mode;
        this.isShow = true;
        this.$root.$emit('header-inert', true)
        this.$emit('list-work-inert', true)
    }

    openHarvestAndShippingModal(harvestRecordId='',shippingRecordId='',mode = ''){
        if(harvestRecordId!=null){
            this.selectedHarvestRecordId = harvestRecordId;
            this.mode = mode;
            this.isShowHarvest = true;
        }else if(shippingRecordId!=null && this.isAdmin){
            this.selectedShippingRecordId = shippingRecordId;
            this.mode = mode;
            this.isShowShipping = true;
        }
        this.$root.$emit('header-inert', true)
        this.$emit('list-work-inert', true)
    }

    openWorkRecordModalCalendar(id = '',mode = ''){
        this.selectedWorkRecordId = id;
        this.mode = mode;
        this.isShow = true;
        this.$root.$emit('header-inert', true)
        this.$emit('list-work-inert', true)
    }

    closeWorkRecordModal() {
    this.selectedWorkRecordId = '';
    this.mode = ''
    this.isShow = false;
    this.$root.$emit('header-inert', false)
    this.$emit('list-work-inert', false)
    }

    closeHarvestModal() {
        this.selectedHarvestRecordId = '';
        this.mode = ''
        this.isShowHarvest = false;
        this.$root.$emit('header-inert', false)
        this.$emit('list-work-inert', false)
    }

    closeShippingModal() {
        this.selectedShippingRecordId = '';
        this.mode = ''
        this.isShowShipping = false;
        this.$root.$emit('header-inert', false)
        this.$emit('list-work-inert', false)
    }

    refreshTable () {
    this.workRecordsList = []
    this.allWorkRecordsList = []
    this.isSpinnerLoading = true
    this.getWorkRecordList(1);
    }

    openPlantingModal(id = null) {
        this.selectedPlantingId = id;
        this.isPlantingShow = true;
        this.$root.$emit('header-inert', true)
        this.$emit('list-work-inert', true)
    }

    closePlantingModal() {
        this.selectedPlantingId = null;
        this.isPlantingShow = false;
        this.$root.$emit('header-inert', false)
        this.$emit('list-work-inert', false)
    }
    
    get filterAgriFields() {
        return this.includeHiddenFlag ? this.agriFields : this.agriFields.filter(a => this.selectedAgriFieldId == a.id || !a.is_hidden);
    }  
    
    get filterWorkItems() {
        return this.includeHiddenFlag ? this.workItems : this.workItems.filter(wi => this.selectedWorkItemId == wi.id || !wi.is_hidden);
    } 

    get filterPlantings() {
        return this.includeHiddenFlag ? this.plantings : this.plantings.filter(p => this.selectedPlantingId == p.id || !p.is_hidden);
    }

    uniqueName(name:string) {
        if (!name) return "---";
        const uniqueList = [...new Set(name.split("、"))];
        return uniqueList.join("、");
    }

    get isReferenceOnly(): boolean {
        return this.$store.getters.loginUser?.pdWhsRecRefOnly === true;
    }
}
